"use strict";
$(function () {
    const notificationClosedKey = "ActiveNotificationClosed";
    const notificationDataKey = "NotificationData";
    if (sessionStorage.getItem(notificationClosedKey) === "true") {
        return;
    }
    let notificationData = sessionStorage.getItem(notificationDataKey);
    if (notificationData) {
        let notificationInfo = JSON.parse(notificationData);
        displayNotification(notificationInfo);
        return;
    }
    $.ajax({
        url: getNotificationUrl,
        type: "GET",
        async: true,
        success: function (response) {
            if (response == null) {
                return;
            }
            if (response) {
                let notificationInfo = {
                    id: response.Id,
                    buttonText: response.ButtonText,
                    cookieName: "system-notification-" + response.UpdatedStamp,
                    text: response.LocalizedMessage,
                    themeClass: "light",
                    title: response.Title,
                    daysUntilExpiry: response.daysUntilExpiry,
                    position: "top",
                };
                displayNotification(notificationInfo);
                sessionStorage.setItem(notificationDataKey, JSON.stringify(notificationInfo));
            }
        },
    });
});
function displayNotification(notificationInfo) {
    let systemNotificationMaker = new SystemNotificationMaker({
        id: notificationInfo.id,
        buttonText: notificationInfo.buttonText,
        cookieName: notificationInfo.cookieName,
        text: notificationInfo.text,
        themeClass: notificationInfo.themeClass,
        title: notificationInfo.title,
        position: notificationInfo.position,
        daysUntilExpiry: notificationInfo.daysUntilExpiry
    });
    if (!systemNotificationMaker.isNotificationChecked) {
        systemNotificationMaker.appendToBody();
        $('#' + systemNotificationMaker.eventPopupIds.popupId).slideToggle();
    }
}
class SystemNotificationMaker {
    constructor(option) {
        this.option = option;
        this.init();
    }
    init() {
        this.eventPopupIds = {
            popupId: `system-notification-popup-container-${this.option.id}`,
            buttonId: `system-notification-button-${this.option.id}`
        };
        this.isNotificationChecked = CookieLibrary.getCookie(this.option.cookieName) != null;
    }
    getHtml() {
        if (this.isNotificationChecked)
            return null;
        return `<div id="${this.eventPopupIds.popupId}" class="system-notification-popup-container theme-${this.option.themeClass}" style="background-color: grey; position: fixed; top: 0; left: 0; right: 0; z-index: 10000; padding: 10px 20px; box-sizing: border-box; display: flex; justify-content: space-between; align-items: center;">
                <div class="system-notification-popup-content">
                    <h4 class="system-notification-popup-headline">${this.option.title}</h4>
                    <p class="system-notification-popup-sub-headline">${this.option.text}</p>
                </div>
                <div>
                    <button id="${this.eventPopupIds.buttonId}" class="btn btn-success" type="button">${this.option.buttonText}</button>
                </div>
            </div>`;
    }
    getBindingConfig() {
        return this.eventPopupIds;
    }
    appendToBody() {
        const htmlContent = this.getHtml();
        if (htmlContent) {
            $(function () {
                $("body").append(htmlContent);
                this.setButtonEvents();
            }.bind(this));
        }
    }
    setButtonEvents() {
        const $popup = $("#" + this.eventPopupIds.popupId);
        $("#" + this.eventPopupIds.buttonId).on("click", () => this.buttonClick());
        $popup.find(".btn-close").on("click", () => $popup.hide());
    }
    buttonClick() {
        CookieLibrary.setCookie(this.option.cookieName, `${this.option.cookieName} was checked`, this.option.daysUntilExpiry);
        $("#" + this.eventPopupIds.popupId).hide();
        sessionStorage.removeItem("NotificationData");
        sessionStorage.setItem("ActiveNotificationClosed", "true");
    }
}
//# sourceMappingURL=SystemNotificationMaker.js.map